import * as React from "react";
import {Link} from "react-router-dom";
import {ProductsEnum, resourcesHelper} from "@falcon/services";

interface IProps {
    policyNumber: string;
}

export class OtherMissedPaymentBanner extends React.Component<IProps> {

    public render(): React.ReactNode {
        return (
            <div className="inner-container">
                <div className="banner dashboard-missed-payment-banner mb-0">
                    <div className="w-100">
                        <div className="overflow-auto">
                            <img src={`/${resourcesHelper.THEME}/img/alert-red.svg`} alt="Red alert icon" className="inline-warning-icon pt-2"/>
                            <div className="banner-text inline-warning-text">
                                <p>We didn't receive payment for your {resourcesHelper.THEME} policy this month.{' '}
                                    You can </p>
                                <Link id={"payNow"}
                                      className="text-decoration-underline cursor-pointer muli-bold-16"
                                      state={{
                                          verifyCardFailed: false,
                                          product: ProductsEnum.WOLF_MOTOR
                                      }}
                                      to={`/dashboard/account/missedPolicyPayment/${this.props.policyNumber}`}> Pay
                                    now</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
